import React, { useEffect, useState } from "react";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
// import Transparentspinner from '../../../Common/Loader/Transparentspinner';
import { Controller, useForm } from "react-hook-form";
import {
  City,
  Countrys,
  FirstName,
  LastName,
  Mobile,
  MobileNo,
  Save,
  State,
} from "../../../../Constant";
import { useLocation } from "react-router";
import Select from "react-select";
import { Country, State as StateList } from "country-state-city";
// import PhoneInput from "react-phone-input-2";
import { Btn } from "../../../../AbstractElements";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
// import { addPackages, updatePersonalInfo } from '../../../../CommonURL';
import {
  postClientUrlWithToken,
  postDataWithToken,
  postMasterToken,
} from "../../../../Utils/restUtils";
import { updateMasterProfile } from "../../../../CommonURL";
import { useSelector } from "react-redux";
import Transparentspinner from "../../../Common/loader/Transparentspinner";
// import { FirstName } from '../../../../Constant';

const EditProfile = ({ props, handleModal }) => {
  const e = props;
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const authState = useSelector((state) => state.auth);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const param1 = params.get("id");

  useEffect(() => {
    handleEditView();
  }, []);

  const handleEditView = () => {
    setValue("fname", e.first_name);
    setValue("lname", e.last_name);
    setValue("phonenumber", e.country_code + e.mobile);
    setValue("city", e.city);
    setValue("countryCode", e.country_code);
    setValue("countryCode", e.country_code);
    const countryObj = Country.getAllCountries().find(
      (item) => item.name === e.country,
    );

    if (countryObj) {
      setSelectedCountry(countryObj);
      setValue("country", countryObj.name);

      const states = StateList.getStatesOfCountry(countryObj.isoCode);

      const stateObj = states.find((item) => item.name === e.state);

      if (stateObj) {
        setSelectedState(stateObj);
        setValue("state", stateObj.name);
      }
    }
  };
  const onSubmit = async (data) => {
    const countryCode = data.countryCode;
    const phoneNumber = data.phonenumber;
    if (phoneNumber.startsWith(countryCode)) {
      setLoading(true);
      const b = phoneNumber.slice(countryCode.length);
      const postRequest = {
        user_id: param1,
        first_name: data.fname,
        last_name: data.lname,
        country_code: countryCode,
        mobile: b,
        country: data.country,
        state: data.state,
        city: data.city,
        ...(data.password && { password: data.password }),
      };
      const editPersonalInfo = await postMasterToken(
        updateMasterProfile,
        postRequest,
      );
      if (editPersonalInfo.data.status) {
        toast.success(editPersonalInfo.data.message);
        handleModal();
        // props.handleModal
      } else {
        setLoading(false);
        toast.error(editPersonalInfo.data.message);
      }
    } else {
      setLoading(false);
      toast.error("phone/country code missing");
    }
    setLoading(false);
  };

  return (
    <>
      {loading && <Transparentspinner />}
      <Form
        className="needs-validation"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
      >
        <Row className="pt-3">
          <Col md="6">
            <Label className="form-label" for="first_name">
              {FirstName}
            </Label>
            <input
              className="form-control"
              id="first_name"
              type="text"
              {...register("fname")}
            />
            {/* <p className="text-danger">{errors.fname?.message}</p> */}
          </Col>
          <Col md="6">
            <Label className="form-label" for="last_name">
              {LastName}
            </Label>
            <input
              className="form-control"
              id="last_name"
              type="text"
              {...register("lname")}
            />
            {/* <p className="text-danger">{errors.lname?.message}</p> */}
          </Col>
        </Row>
        <Row className=" pt-3">
          <Col md="6">
            <Label className="form-label" for="first_name">
              {Mobile}
            </Label>
            <Controller
              name="phonenumber"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <PhoneInput
                  {...field}
                  country={"in"}
                  enableSearch={true}
                  onChange={(value, country) => {
                    setValue("countryCode", country.dialCode);
                    field.onChange(value);
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "46px",
                    padding: "10px",
                    paddingLeft: "50px",
                    fontSize: "16px",
                    borderRadius: "8px",
                    borderColor: "rgba(83, 70, 134, 0.1019607843)",
                  }}
                  searchClass="none"
                />
              )}
            />
            <span className="text-danger">
              {/* {errors.mobile && MobileNoError} */}
            </span>
          </Col>
          <Col md="6">
            <Label className="form-label">{Countrys}</Label>

            <Controller
              name="country"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  options={Country.getAllCountries()}
                  getOptionLabel={(opt) => `${opt.name} (+${opt.phonecode})`}
                  getOptionValue={(opt) => opt.isoCode}
                  value={selectedCountry}
                  onChange={(item) => {
                    setSelectedCountry(item);
                    setSelectedState(null);

                    setValue("country", item.name);
                    setValue("countryCode", item.phonecode);
                    setValue("state", "");
                  }}
                />
              )}
            />
          </Col>
        </Row>
        <Row className="g-3 pt-3">
          <Col md="6">
            <Label className="form-label">{State}</Label>

            <Controller
              name="state"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  options={StateList.getStatesOfCountry(
                    selectedCountry?.isoCode,
                  )}
                  getOptionLabel={(opt) => opt.name}
                  getOptionValue={(opt) => opt.isoCode}
                  value={selectedState}
                  onChange={(item) => {
                    setSelectedState(item);
                    setValue("state", item.name);
                  }}
                  isDisabled={!selectedCountry}
                />
              )}
            />
          </Col>
          <Col md="6">
            <Label className="form-label" for="last_name">
              {City}
            </Label>
            <input
              className="form-control"
              id="city"
              type="text"
              {...register("city")}
            />
            {/* <p className="text-danger">{errors.lname?.message}</p> */}
          </Col>
        </Row>
        <FormGroup></FormGroup>
        <Btn attrBtn={{ color: "primary" }} type="submit">
          {Save}
        </Btn>
      </Form>
    </>
  );
};

export default EditProfile;
